module.exports = "/_next/static/images/alerts-mobile-8056cd8452e7e0124b7aa5b9413a13d2.png";